import { render, staticRenderFns } from "./InfoEdu.vue?vue&type=template&id=18bc7e7e"
import script from "./InfoEdu.vue?vue&type=script&lang=js"
export * from "./InfoEdu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports